module.exports = []


//////////////////
// WEBPACK FOOTER
// ./static/tech-city/metadata/interactive.json
// module id = 2124
// module chunks = 80